// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_53-2";
export var blackBorderOnHover = "_53-7";
export var cell = "_53-6";
export var cellContainer = "_53-3";
export var checked = "_53-8";
export var disabled = "_53-5";
export var featuredIconCellContainer = "_53-9";
export var featuredIconTextContainer = "_53-b";
export var featuredIconWrapper = "_53-a";
export var noBorder = "_53-c";
export var orangeSelectedRow = "_c2-3";
export var overflowableText = "_53-0";
export var overflowableTextContainer = "_53-1";
export var row = "_51-0";
export var rowCheckboxCell = "_53-4";
export var selectableTable = "_c2-2";